export const FREE_LIMITS = {
  activeServices: 5,
  series: 2,
  episodesPerSeries: 10
};

// Tope técnico alto para evitar abuso/performance.
// En UI lo mostramos como "Ilimitado".
export const PREMIUM_LIMITS = {
  activeServices: 999,
  series: 999,
  episodesPerSeries: 999
};

export function getEffectiveLimits(isPremium) {
  return isPremium ? PREMIUM_LIMITS : FREE_LIMITS;
}

